"use client";

import { Adsense } from "@ctrl/react-adsense";
import { useUser } from "@clerk/nextjs";
import { getUserPlanByMetadata } from "@/helper/user/client";

const variants = {
  vertical: {
    property: "9151824066",
  },
  horizontal: {
    blog: "4507965494",
    tools: "7585066306",
    guide: "1755715629",
    property: "4850714451",
  },
  card: {
    propertiesList: "4478798497",
  },
};

type OrientationType = keyof typeof variants;

// Define more specific prop types with discriminated unions
type AdSenseResponsiveProps =
  | {
      orientation: "vertical";
      variant: keyof typeof variants.vertical;
    }
  | {
      orientation: "horizontal";
      variant: keyof typeof variants.horizontal;
    }
  | {
      orientation: "card";
      variant: keyof typeof variants.card;
    };

function getSlotValue(orientation: OrientationType, variant: string): string {
  if (orientation === "vertical") {
    return variants.vertical[variant as keyof typeof variants.vertical];
  } else if (orientation === "horizontal") {
    return variants.horizontal[variant as keyof typeof variants.horizontal];
  } else if (orientation === "card") {
    return variants.card[variant as keyof typeof variants.card];
  }
  return "";
}

export const AdSenseResponsiveCheckPlan = ({
  orientation,
  variant,
}: AdSenseResponsiveProps) => {
  const { user } = useUser();
  const { hasPaidPlan } = getUserPlanByMetadata(user?.publicMetadata);

  if (hasPaidPlan) return null;

  return (
    <div className="w-full min-w-32 min-h-32">
      <Adsense
        client="ca-pub-1764245778079932"
        slot={getSlotValue(orientation, variant)}
        style={{ display: "block" }}
        layout="display"
        format="auto"
      />
    </div>
  );
};

export const AdSenseResponsive = ({
  orientation,
  variant,
}: AdSenseResponsiveProps) => {
  return (
    <div className="w-full min-w-32 min-h-32">
      <Adsense
        client="ca-pub-1764245778079932"
        slot={getSlotValue(orientation, variant)}
        style={{ display: "block" }}
        layout="display"
        format="auto"
      />
    </div>
  );
};
